import { Link, Text } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React, { FunctionComponent } from 'react'
import styles from './styles.module.css'
import clsx from 'clsx'
import { useIsCountry } from '../../state'
import { Country } from '@afterpay/types'
import { PortalId } from '../../layouts/types'

interface Props {
  visible: boolean
  shouldRender?: boolean
}

export const Footer: FunctionComponent<Props> = ({ visible = false, shouldRender = true }) => {
  const { t } = useTranslation()
  const footerContentClassName = clsx(styles.footerContent, visible && styles.visible)
  const isAUCountry = useIsCountry(Country.AU)
  if (!shouldRender) {
    return null
  }

  return (
    <div className={styles.footer}>
      <div className={styles.dockedCTA} id={PortalId.DockedFooter} />
      <div className={footerContentClassName} data-testid='footer-content'>
        <Text size='XS'>{t('common:footerCopyright', { year: new Date().getFullYear() })}</Text>
        <Link size='XS' kind='Underline' testNameSpace='terms' href={t('common:termsOfServiceUrl')} target='_blank'>
          {t('common:footerTerms')}
        </Link>
        <Link size='XS' kind='Underline' testNameSpace='privacy-policy' href={t('common:privacyPolicyUrl')} target='_blank'>
          {t('common:footerPrivacy')}
        </Link>
      </div>
      {isAUCountry && (
        <div className='text-center'>
          <Text size='XS'>{t('common:creditLicence', { defaultValue: '' })}</Text>
        </div>
      )}
    </div>
  )
}
